import { render, staticRenderFns } from "./ow.vue?vue&type=template&id=1c511bfa&"
import script from "./ow.vue?vue&type=script&lang=js&"
export * from "./ow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports